import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { injectReportsHttpApiService } from '@core/reports-contracts';

@Injectable()
export class ReportsDetailsHttpClientBase {
  private readonly httpApi = injectReportsHttpApiService();

  public fetchOne<TData, TFragment, TResponse>(
    {
      data,
      fragment,
      page,
    }: {
      data: TData;
      fragment: TFragment;
      page: number;
    },
    getDetailsKey: (data: TData, fragment: TFragment, page: number) => string,
    getDetailsParams: (data: TData, fragment: TFragment, page: number) => any,
  ): Observable<TResponse & { key: string }> {
    const params = getDetailsParams(data, fragment, page);
    const key = getDetailsKey(data, fragment, page);

    return this.httpApi.get<TResponse>('/details', params).pipe(map(data => ({ ...data, key })));
  }
}
